import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';

@Component({
  selector: 'brn-twilio-connection-modal',
  templateUrl: './twilio-connection-modal.component.html',
  styleUrls: ['./twilio-connection-modal.component.scss'],
})
export class TwilioConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  twilioForm = this.formBuilder.group({
    msid: [''],
    phone: ['', Validators.required],
    sid: ['', Validators.required],
    token: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<TwilioConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      const providerData = data.providerData;
      this.newConnection = false;
      this.twilioForm.patchValue(providerData);
    }
  }

  ngOnInit(): void {}

  get validForm(): boolean {
    return this.twilioForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.twilioForm.value;
    this.store.dispatch(new CreateBotConnection('twilio', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.twilioForm.value;
    this.store.dispatch(new UpdateBotConnection('twilio', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('twilio'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
